import { AfterViewInit, Component, DoCheck, ElementRef, HostListener, ViewChild } from '@angular/core';
import { WindowService } from '../../shared/window.service';

@Component({
  selector: 'lp2-sticky-bottom',
  templateUrl: './sticky-bottom.component.html',
  styleUrls: ['./sticky-bottom.component.scss'],
})
export class StickyBottomComponent implements AfterViewInit, DoCheck {
  @ViewChild('parent') parent: ElementRef;
  @ViewChild('content') content: ElementRef;

  private className = 'sticky-bottom';

  constructor(private windowService: WindowService) {}

  ngDoCheck() {
    this.fixParentHeight();
  }

  fixParentHeight() {
    if (
      this.parent.nativeElement.clientHeight !== this.content.nativeElement.clientHeight ||
      !this.parent.nativeElement.style.height
    ) {
      this.parent.nativeElement.style.height = this.content.nativeElement.clientHeight + 'px';
      this.checkAndMakeSticky();
    }
  }

  ngAfterViewInit() {
    // Calling checkAndMakeSticky repeatedly for a period of time.
    // to solve the problem of footer loading before some of the content.
    const initialCheck = setInterval(() => this.checkAndMakeSticky(), 500);

    setTimeout(() => {
      clearInterval(initialCheck);
    }, 2000);
  }

  @HostListener('window:touchmove', ['$event'])
  @HostListener('window:scroll', ['$event'])
  @HostListener('window:resize', ['$event'])
  @HostListener('window:orientationchange', ['$event'])
  checkAndMakeSticky() {
    const parentElement = this.parent.nativeElement;
    const contentElement = this.content.nativeElement;

    const parentElementPosition = parentElement.getBoundingClientRect();
    const windowHeight = this.windowService.getWindowHeight();
    if (windowHeight < parentElementPosition.bottom) {
      contentElement.classList.add(this.className);
    } else {
      contentElement.classList.remove(this.className);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/footer/sticky-bottom/sticky-bottom.component.ts